import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../utility/NavigationHelper";
import {
  Text,
  Image,
  TouchableOpacity,
  View,
  TouchableHighlight,
} from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { useEffect, useState } from "react";

import React from "react";

import Tooltip from "react-native-walkthrough-tooltip";
import { AppColors } from "../utility/AppColors";
import { AppImages } from "../utility/AppImages";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppScreens } from "../screens/Utility/AppScreens";
import { CropImage } from "./choose-avatar-components/CropImage";
import { formatDate } from "../utility/Index";
import BuyTicketModal from "../screens/Auth/WebScreens/Modals/BuyTicketModal";
import SignUpModal from "../screens/Auth/WebScreens/Modals/SignUpModal";
import { EVENT_STATUS } from "../utility/LiveStreamSocket/LiveStreamConfig";
import SignUpWalkthrough from "./walk-through-common-components/homeScreenTooltips/SignUpWalkthrough";
import GetTicketWalkthrough from "./walk-through-common-components/homeScreenTooltips/GetTicketWalkthrough";
import Avatar from "./choose-avatar-components/Avatar";
import SvgImage from "./choose-avatar-components/SvgImage";

export default function Card(props) {
  const {
    index,
    item,
    heading,
    accessToken,
    screenName,
    eventID = "",
    userData,
    userProfileData,
    // getTicketTapped,
    loadEventDetailScreen,
    CardData,
  } = props;
  const navigation = useNavigation();
  const [isGetTicket, setIsGetTicket] = useState(false);

  useEffect(() => {
    if (item.eventID === eventID) {
      setIsGetTicket(true);
    } else {
      setIsGetTicket(false);
    }
  }, [item.eventID, eventID]);

  const [isSignUp, setIsSignUp] = useState(false);
  const [attendeeIDs, setAttendeeIDs] = useState(item.attendeeIDs || []);
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const flag = item.type === "Private" ? 0 : 1;

  const percentage =
    attendeeIDs && item.minimumAttendees
      ? Math.round((attendeeIDs.length * 100) / item.minimumAttendees)
      : 0;

  const isUserAttendee =
    userData?.username && attendeeIDs?.includes(userData.username);
  const isPlayer =
    userData?.username && item?.participantIDs?.includes(userData.username);

  const stakes = item?.stakes ?? []; // Use new stakes structure

  const medalsData = [
    { id: 0, name: "Coin", image: AppImages.icCoinBelt, value: 0 },
    { id: 1, name: "Bronze", image: AppImages.icBronzeBelt, value: 0 },
    { id: 2, name: "Silver", image: AppImages.icSilverBelt, value: 0 },
    { id: 3, name: "Gold", image: AppImages.icGoldBelt, value: 0 },
    { id: 4, name: "Platinum", image: AppImages.icPlatinumBelt, value: 0 },
  ];

  // const updatedMedals = medalsData.map((medal) => {
  //   const safeStakes = Array.isArray(stakes) ? stakes : [];
  //   const stake = safeStakes.find((s) => s.type === medal.name);
  //   return {
  //     ...medal,
  //     value: stake ? stake.quantity : 0,
  //   };
  // });

  const updatedMedals = medalsData
    .map((medal) => {
      const safeStakes = Array.isArray(stakes) ? stakes : [];
      const stake = safeStakes.find((s) => s.type === medal.name);
      return {
        ...medal,
        value: stake ? stake.quantity : 0,
      };
    })
    .filter((medal) => medal.value > 0);

  return (
    <TouchableOpacity
      style={[
        styles.cardContainer,
        (deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM) && {
          marginLeft: index === 0 ? 20 : 0,
          marginRight: CardData.length - 1 === index ? 20 : 0,
        },
      ]}
      onPress={() => {
        if (heading === "Past Events") {
          navigateToScreen(navigation, AppScreens.PastEvent, {
            eventID: item.eventID,
          });
        } else if (
          screenName === "MyEvent" &&
          heading === "Events I'm Watching"
        ) {
          navigateToScreen(navigation, AppScreens.GameShowScreen, {
            eventID: item.eventID,
          });
        } else if (screenName === "MyEvent") {
          navigateToScreen(navigation, AppScreens.OnGoingEvents, {
            eventID: item.eventID,
          });
        } else if (item.status === EVENT_STATUS.LIVE) {
          navigateToScreen(navigation, AppScreens.LiveStreaming, {
            eventId: item.eventID,
          });
        } else if (item.status === EVENT_STATUS.UPCOMING) {
          navigateToScreen(navigation, AppScreens.GameShowScreen, {
            eventID: item.eventID,
          });
        }
      }}
    >
      <View
        style={{
          position: "relative",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image
          source={AppImages.icCardBg}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            resizeMode: "cover",
            borderTopRightRadius: 16,
            borderTopLeftRadius: 16,
          }}
        />

        <View
          style={{
            flexDirection: "row",
            // alignItems: "baseline",
            justifyContent: "space-between",
            position: "relative",
            width: "100%",
          }}
        >
          {/* First Player */}
          <View style={{ alignItems: "center" }}>
            <Avatar
              src={
                item?.participantDetails[0] &&
                item?.participantDetails[0]?.profilePicture !== "" // Check if first participant exists
                  ? item?.participantDetails[0]?.profilePicture // If exists, use their profile picture
                  : "https://squadify-avatar.s3.eu-west-2.amazonaws.com/panda.svg"
              }
              variant="eventCard"
            />
          </View>
          <View
            style={{
              position: "absolute",
              paddingHorizontal: 8,
              paddingVertical: 3,
              borderRadius: 7,
              backgroundColor: "#655AFF80",
              opacity: 1,
              bottom: 0,
              left: 0,
            }}
          >
            <Text
              style={
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? AppFontStyle.SEMIBOLD_ANYBODY_10
                  : AppFontStyle.SEMIBOLD_ANYBODY_16
              }
            >
              @{" "}
              {item?.participantDetails[0] // Check if first participant exists
                ? item?.participantDetails[0]?.userID // If exists, use their profile picture
                : "user"}
            </Text>
          </View>

          {/* Center Game Image */}
          <View
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
            }}
          >
            <Image
              source={{ uri: item?.gameImage }}
              style={{
                width:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? 87
                    : 161,
                height:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? 50
                    : 84,
                borderRadius: 11,
                resizeMode: "contain",
              }}
            />
            <View
              style={{
                position: "absolute",
                top: 0,
                left: "50%",
                transform: [
                  { translateX: "-50%" },
                  {
                    translateY:
                      deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                        ? "50%"
                        : "10%",
                  },
                ],
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: 10,
                borderRadius: 335,
                backgroundColor: "rgba(255, 255, 255, 0.49)",
                flexShrink: 0,
                width: 40,
                height: 40,
              }}
            >
              <Image
                source={AppImages.icVsLogo}
                style={{
                  width: 18,
                  height: 40,
                }}
                resizeMode="contain"
              />
            </View>
          </View>

          {/* Second Player */}
          <View style={{ alignItems: "center" }}>
            {screenName === "MyEvent" && item.checkInStatus.challenger && (
              <View
                style={{
                  paddingVertical: 8,
                  paddingHorizontal: 12,
                  borderRadius: 8,
                  backgroundColor: AppColors.blue_051639,
                  left:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? "-25%"
                      : "-50%",
                  bottom:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 20
                      : 25,
                  position: "absolute",
                  opacity:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 0.7
                      : 1,
                  zIndex: 1,
                }}
              >
                <Text
                  style={
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? AppFontStyle.SEMIBOLD_ANYBODY_8
                      : AppFontStyle.SEMIBOLD_ANYBODY_12
                  }
                >
                  Attendance confirmed
                </Text>
              </View>
            )}
            <View>
              {item?.participantDetails[1] &&
              item?.participantDetails[1]?.profilePicture !== "" ? (
                <Avatar
                  variant="eventCard"
                  src={
                    item?.participantDetails[1] &&
                    item?.participantDetails[1]?.profilePicture !== "" // Check if second participant exists
                      ? item?.participantDetails[1]?.profilePicture // If exists, use their profile picture
                      : "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                  }
                />
              ) : (
                <Image
                  source={AppImages.icEmptyOpponent}
                  style={{
                    height:
                      deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                        ? 94
                        : 109,
                    width:
                      deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                        ? 87
                        : 100,
                    resizeMode: "contain",
                  }}
                />
              )}
            </View>
            <View
              style={{
                position: "absolute",
                paddingHorizontal: 8,
                paddingVertical: 3,
                borderRadius: 7,
                backgroundColor: "#655AFF80",
                opacity: 1,
                bottom: 0,
                right: 0,
              }}
            >
              <View
                style={{ flexDirection: "row", gap: 5, alignItems: "center" }}
              >
                {screenName === "MyEvent" && (
                  <SvgImage src={AppImages.icVerify} variant="cardVerify" />
                )}{" "}
                <Text
                  style={
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? AppFontStyle.SEMIBOLD_ANYBODY_10
                      : AppFontStyle.SEMIBOLD_ANYBODY_16
                  }
                >
                  @
                  {item?.participantDetails[1] // Check if second participant exists
                    ? item?.participantDetails[1]?.userID // If exists, use their profile picture
                    : "............."}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </View>

      <View style={{ padding: 10 }}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 12,
          }}
        >
          <Text
            style={
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? AppFontStyle.BOLD_ANYBODY_12
                : AppFontStyle.BOLD_ANYBODY_20
            }
          >
            {item?.eventTitle}
          </Text>
          <View style={{ flexDirection: "row", gap: 5, alignItems: "center" }}>
            <Image
              source={AppImages.icWhiteEye}
              style={{
                width: 16,
                height: 16,
                resizeMode: "contain",
              }}
            />
            <Text
              style={
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? AppFontStyle.REGULAR_ANYBODY_10
                  : AppFontStyle.REGULAR_ANYBODY_12
              }
            >
              {item?.attendeeCount}
            </Text>
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems:
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? "flex-start"
                : "center",
            marginBottom:
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? 10
                : 20,
          }}
        >
          <View>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? AppFontStyle.BOLD_ANYBODY_10
                  : AppFontStyle.BOLD_ANYBODY_15,
                { color: AppColors.white },
              ]}
            >
              <Text>
                {heading === "Past Events"
                  ? `Total credits won: ${item?.totalCredits}`
                  : `Worth ${item?.totalCredits} credits`}
                {heading === "My KallOuts" || heading === "Opponents Challenges"
                  ? ` (£${item?.totalBalance})`
                  : ""}
              </Text>
            </Text>
            {heading === "My KallOuts" ||
            heading === "Opponents Challenges" ? null : (
              <View style={{ alignItems: "flex-start", marginTop: 5 }}>
                {heading === "Past Events" ? (
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 10,
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? AppFontStyle.BOLD_ANYBODY_12
                          : AppFontStyle.BOLD_ANYBODY_14
                      }
                    >
                      {item?.totalCredits}
                    </Text>
                    <Text
                      style={
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? AppFontStyle.BOLD_ANYBODY_14
                          : AppFontStyle.BOLD_ANYBODY_18
                      }
                    >
                      £{item?.totalBalance}
                    </Text>
                  </View>
                ) : (
                  <View
                    style={{
                      padding:
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? 5
                          : 12,
                      borderRadius:
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? 5
                          : 10,
                      backgroundColor: AppColors.purple_423B49,
                    }}
                  >
                    <Text
                      style={
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? AppFontStyle.BOLD_ANYBODY_18
                          : AppFontStyle.BOLD_ANYBODY_28
                      }
                    >
                      £{item?.totalBalance}
                    </Text>
                  </View>
                )}
              </View>
            )}
          </View>
          {heading === "My KallOuts" ||
          heading === "Opponents Challenges" ? null : (
            <View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 3
                      : 10,
                }}
              >
                {updatedMedals.map((medal) => (
                  <View
                    key={medal.id}
                    style={{
                      alignItems: "center",
                    }}
                  >
                    <SvgImage
                      src={medal.image}
                      variant="cardMedal"
                      item={medal}
                    />
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? AppFontStyle.BOLD_ANYBODY_10
                          : AppFontStyle.BOLD_ANYBODY_16,
                        {},
                      ]}
                    >
                      {medal.value}
                    </Text>
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? AppFontStyle.BOLD_ANYBODY_8
                          : AppFontStyle.REGULAR_ANYBODY_12,
                        {},
                      ]}
                    >
                      {medal.name}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
          )}
        </View>

        {item.status === "cancelled" ? (
          <Text
            style={[
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? AppFontStyle.BOLD_ANYBODY_12
                : AppFontStyle.BOLD_ANYBODY_20,
              {
                color: AppColors.red_AF0707,
              },
            ]}
          >
            Event is cancelled
          </Text>
        ) : heading === "Past Events" ? (
          <View style={{ flexDirection: "row", gap: 7, alignItems: "center" }}>
            <Text
              style={
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? AppFontStyle.SEMIBOLD_ANYBODY_12
                  : AppFontStyle.SEMIBOLD_ANYBODY_14
              }
            >
              Total Gift received:
            </Text>
            <Text
              style={
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? AppFontStyle.BOLD_ANYBODY_14
                  : AppFontStyle.BOLD_ANYBODY_18
              }
            >
              {item?.totalGiftValue}
            </Text>

            <SvgImage src={AppImages.icThemeGift} variant="cardGift" />
          </View>
        ) : (
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <View
              style={{ flexDirection: "row", gap: 5, alignItems: "center" }}
            >
              <Image
                source={AppImages.icCalender}
                style={{
                  width: 20,
                  height: 20,
                  resizeMode: "contain",
                }}
              />
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? AppFontStyle.BOLD_ANYBODY_12
                    : AppFontStyle.BOLD_ANYBODY_20,
                  { color: AppColors.white },
                ]}
              >
                {formatDate(item?.eventStartTime)}
              </Text>
            </View>

            {screenName === "MyEvent" ? (
              <View style={{ flexDirection: "row", gap: 10 }}>
                {heading === "Events I'm Watching" && (
                  <Image
                    source={AppImages.icTicket}
                    style={{ height: 26, width: 50, borderRadius: 3 }}
                  />
                )}
                <TouchableOpacity
                  style={{
                    backgroundColor: AppColors.appViolentColor_6D08C3,
                    paddingHorizontal: 12,
                    paddingVertical: 8,
                    borderRadius: 10,
                    zIndex: 9999,
                  }}
                  onPress={() => {
                    heading === "Events I'm Watching"
                      ? navigateToScreen(
                          navigation,
                          AppScreens.GameShowScreen,
                          {
                            eventID: item.eventID,
                          }
                        )
                      : navigateToScreen(navigation, AppScreens.OnGoingEvents, {
                          eventID: item.eventID,
                        });
                  }}
                >
                  <Text
                    style={[
                      deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                        ? AppFontStyle.BOLD_ANYBODY_10
                        : AppFontStyle.MEDIUM_ANYBODY_12,
                      {},
                    ]}
                  >
                    {heading === "Events I'm Watching"
                      ? "View details"
                      : "Manage Event"}
                  </Text>
                </TouchableOpacity>
              </View>
            ) : (
              <View
                style={{ flexDirection: "row", gap: 10, alignItems: "center" }}
              >
                <Text style={[AppFontStyle.REGULAR_ANYBODY_10, {}]}>
                  Free entry
                </Text>
                {userData?.username && !isPlayer ? (
                  !isUserAttendee ? (
                    flag === 0 ? (
                      //get ticket - Private event

                      <TouchableOpacity
                        style={{
                          backgroundColor: AppColors.appViolentColor_6D08C3,
                          paddingHorizontal: 12,
                          paddingVertical: 8,
                          borderRadius: 10,
                        }}
                        onPress={() => {
                          console.log("Get Ticket button pressed");
                          setIsGetTicket(true);
                        }}
                      >
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                              ? AppFontStyle.BOLD_ANYBODY_10
                              : AppFontStyle.MEDIUM_ANYBODY_12,
                            {},
                          ]}
                        >
                          Get-Ticket
                        </Text>
                      </TouchableOpacity>
                    ) : (
                      //get Signup - Public event
                      <TouchableOpacity
                        style={{
                          backgroundColor: AppColors.appViolentColor_6D08C3,
                          paddingHorizontal: 12,
                          paddingVertical: 8,
                          borderRadius: 10,
                        }}
                        onPress={() => {
                          console.log("Sign Up button pressed");
                          setIsSignUp(true);
                        }}
                      >
                        <Text
                          style={[
                            deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                              ? AppFontStyle.BOLD_ANYBODY_10
                              : AppFontStyle.MEDIUM_ANYBODY_12,
                            {},
                          ]}
                        >
                          Sign-Up
                        </Text>
                      </TouchableOpacity>
                    )
                  ) : flag === 0 ? (
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? AppFontStyle.BOLD_ANYBODY_10
                          : AppFontStyle.BOLD_ANYBODY_12,
                        {
                          // color: AppColors.white,
                          // marginTop: 10,
                          // width: 150,
                          width:
                            deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                              ? 60
                              : "auto",
                          textAlign: "right",
                        },
                      ]}
                      // numberOfLines={1}
                      // ellipsizeMode="tail"
                    >
                      Already Purchased
                    </Text>
                  ) : (
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? AppFontStyle.BOLD_ANYBODY_10
                          : AppFontStyle.BOLD_ANYBODY_12,
                        {
                          // color: AppColors.white,
                          // marginTop: 10,
                          // width: 150,
                          width:
                            deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                              ? 60
                              : "auto",
                          textAlign: "right",
                        },
                      ]}
                      // numberOfLines={1}
                      // ellipsizeMode="tail"
                    >
                      Already signedup
                    </Text>
                  )
                ) : null}
              </View>
            )}
          </View>
        )}
        {isSignUp && (
          <SignUpModal
            accessToken={accessToken}
            userId={userData.username}
            item={item}
            closeSignUp={(success) => {
              if (success) {
                setAttendeeIDs([...attendeeIDs, userData.username]); // Add the user to attendeeIDs after successful sign-up
                setIsSignUp(false); // Close the modal
              }
              setIsSignUp(false); // Close the modal
            }}
            setIsSignUp={setIsSignUp}
          />
        )}
        {isGetTicket && (
          <BuyTicketModal
            accessToken={accessToken}
            item={item}
            userData={userData}
            userProfileData={userProfileData}
            closeButTicket={(success) => {
              if (success) {
                setAttendeeIDs([...attendeeIDs, userData.username]);
                setIsGetTicket(false);
              }
              setIsGetTicket(false);
            }}
            setIsGetTicket={setIsGetTicket}
          />
        )}
      </View>
    </TouchableOpacity>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    cardContainer: {
      width: 470,
      borderColor: AppColors.gray_5C5C5C,
      borderWidth: 1.5,
      borderRadius: 16,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      cardContainer: {
        width: 470,
      },
    },
    [DEVICE_SIZES.LG]: {
      cardContainer: {
        width: 470,
      },
    },
    [DEVICE_SIZES.SM]: {
      cardContainer: {
        width: 310,
      },
    },
    [DEVICE_SIZES.XS]: {
      cardContainer: {
        width: 310,
      },
    },
  }
);
